"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadersProvider = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _constantsGenerated = require("../constants-generated");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */

const HeadersProvider = ({
  children
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerId,
    token
  } = (0, _auth.useToken)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
    customerId: customerId,
    language: language,
    sourceAppName: _constantsGenerated.PACKAGE_NAME,
    tenant: tenant,
    token: token,
    children: children
  });
};
exports.HeadersProvider = HeadersProvider;